'use client'

import { filterBuilderAttributes } from '@src/utils/builder.util'
import { cn } from '@src/utils/tailwind'

import { textStyleMap } from '../Builder/Text/Text'
import { type IconNames, IconText, type IconTypes } from '../IconText/IconText'

interface ChecklistProps {
  items?: Array<{ value?: string }>
  checkColor?: string
  checkIcon?: (typeof IconNames)[number]
  iconType?: (typeof IconTypes)[number]
  iconSize?: number
  textStyle?: keyof typeof textStyleMap
  separation?: number
  attributes?: any
}

export const Checklist = (props: ChecklistProps) => {
  const {
    items = [],
    checkColor = '#825BB5',
    checkIcon = 'CheckIcon',
    iconType = 'solid',
    iconSize = 16,
    textStyle = 'Body MD',
    separation = 8,
    attributes,
  } = props
  if (!items) return null

  return (
    <div
      {...filterBuilderAttributes(attributes)}
      className={cn('flex w-full flex-col', attributes?.className)}
      style={{
        gap: separation,
      }}
    >
      {items.map(({ value }, i) => (
        <IconText
          iconColor={checkColor}
          iconName={checkIcon}
          iconType={iconType}
          iconSize={iconSize}
          key={`${value}${i}`}
        >
          <span
            className={cn('w-fit', textStyleMap[textStyle])}
            dangerouslySetInnerHTML={{ __html: value ?? '' }}
          />
        </IconText>
      ))}
    </div>
  )
}
